import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RequireAuth } from '@guards/require-auth';
import { RequireRole } from '@guards/require-role';
import { ToastHost } from '@components/toast';

const LabsoftwareShell = lazy(() => import('@pages/labsoftware/labsoftware.page'));
const ClientPortalShell = lazy(() => import('@pages/client-portal/client-portal.page'));
const EmployeePortalShell = lazy(() => import('@pages/employee-portal/employee-portal.page'));
const PlatformAdminShell = lazy(() => import('@pages/platform/platform.page'));
const ForbiddenPage = lazy(() => import('@pages/forbidden/forbidden.page'));
const PreviewPage = lazy(() => import('@pages/preview/preview.page'));
const MobileChatPage = lazy(() => import('@pages/mobile-chat/mobile-chat.page'));

export function App(): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <Suspense fallback={<div style={{ padding: 32 }}>{t('common.loading')}</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/labsoftware" replace />} />
          <Route
            path="/labsoftware/*"
            element={
              <RequireAuth>
                <LabsoftwareShell />
              </RequireAuth>
            }
          />
          <Route
            path="/client/*"
            element={
              <RequireRole role="dentist">
                <ClientPortalShell />
              </RequireRole>
            }
          />
          <Route
            path="/employee/*"
            element={
              <RequireRole role="employee">
                <EmployeePortalShell />
              </RequireRole>
            }
          />
          <Route
            path="/platform/*"
            element={
              <RequireRole role="platform-admin">
                <PlatformAdminShell />
              </RequireRole>
            }
          />
          {import.meta.env.DEV ? (
            <Route path="/__preview" element={<PreviewPage />} />
          ) : null}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route
            path="/mobile-chat"
            element={
              <RequireAuth>
                <MobileChatPage />
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
      <ToastHost />
    </>
  );
}
